import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { gql } from "@apollo/client";
import { createPageInfo } from "./helper";
export const typeDef = gql`
  type CanvasStructure {
    type: String
    id: Int
  }

  type CanvasPageMeta {
    title: String
    keywords: String
    description: String
    robots: String
  }

  type CanvasStructureConnection {
    data: [CanvasStructure]
    meta: CanvasPageMeta
    pageInfo: PageInfo
  }

  type Query {
    canvas(idKey: String, offset: Int, limit: Int): CanvasStructureConnection
  }
`;
export const resolvers = {
  Query: {
    canvas: async (_parent, _ref, _ref2) => {
      let {
        idKey,
        offset,
        limit
      } = _ref;
      let {
        dataSources
      } = _ref2;
      try {
        var _res$values;
        const res = await dataSources.canvas.getCanvas(idKey);
        const structure = res.structure;
        const meta = _objectSpread({
          title: res.name
        }, (_res$values = res.values) === null || _res$values === void 0 ? void 0 : _res$values.meta);
        return {
          data: structure.slice(offset, offset + limit),
          meta,
          pageInfo: createPageInfo({
            limit,
            offset,
            count: structure.length
          })
        };
      } catch (e) {
        console.log("canvas schema query error", e);
      }
    }
  }
};